import { render, staticRenderFns } from "./FundAllocation.vue?vue&type=template&id=5f87834c&scoped=true&"
import script from "./FundAllocation.vue?vue&type=script&lang=js&"
export * from "./FundAllocation.vue?vue&type=script&lang=js&"
import style0 from "./FundAllocation.vue?vue&type=style&index=0&id=5f87834c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87834c",
  null
  
)

export default component.exports